/* Chave PIX do captador, usada no pagamento da comissão.

   Cada um edita a própria chave; o admin enxerga a de todos na aba
   Financeiro. A policy de update em perfis permite exatamente isso. */

import { $, esc, toast } from "../util.js";
import { S } from "../estado.js";
import { salvarPix } from "../api/comissoes.js";
import { desenhar } from "../render.js";

const TIPOS = [
  ["celular",   "Celular"],
  ["cpf",       "CPF"],
  ["email",     "E-mail"],
  ["aleatoria", "Chave aleatória"]
];

export function abrirPix(){
  const p = S.perfil || {};
  $("#modalHost").innerHTML = `<div class="scrim" id="scrimPix"><div class="modal" role="dialog" aria-modal="true" style="max-width:440px">
    <div class="modal-head"><h2>Minha chave PIX</h2><button class="x" id="pxX" aria-label="Fechar">&times;</button></div>
    <div class="modal-body">
      <p class="hint">É para onde a comissão é enviada. Confira com atenção: chave errada significa pagamento na conta de outra pessoa.</p>
      <div class="field"><label for="pxTipo">Tipo de chave</label>
        <select id="pxTipo">
          <option value="">Selecione</option>
          ${TIPOS.map(([v,n]) => `<option value="${v}" ${p.pix_tipo===v?"selected":""}>${n}</option>`).join("")}
        </select></div>
      <div class="field"><label for="pxChave">Chave</label>
        <input id="pxChave" type="text" value="${esc(p.pix||"")}" placeholder="Digite a chave" autocomplete="off"></div>
      <div class="err" id="pxErro">Preencha o tipo e a chave.</div>
    </div>
    <div class="modal-foot">
      <div class="spacer"></div>
      <button class="btn ghost" id="pxCancel">Cancelar</button>
      <button class="btn" id="pxSave">Salvar</button>
    </div></div></div>`;

  const fechar = () => { $("#modalHost").innerHTML = ""; };
  $("#pxX").onclick = fechar;
  $("#pxCancel").onclick = fechar;
  $("#scrimPix").addEventListener("mousedown", e => { if (e.target.id === "scrimPix") fechar(); });

  $("#pxSave").onclick = async () => {
    const tipo = $("#pxTipo").value;
    const chave = $("#pxChave").value.trim();
    if (!tipo || !chave){ $("#pxErro").style.display = "block"; return; }

    const b = $("#pxSave"); b.disabled = true; b.textContent = "Salvando...";
    try {
      await salvarPix(S.perfil.id, chave, tipo);
      S.perfil.pix = chave;
      S.perfil.pix_tipo = tipo;
      fechar();
      /* O Financeiro do captador mostra um aviso enquanto a chave está vazia.
         Redesenhar aqui faz o aviso sumir na hora, sem trocar de aba. */
      desenhar();
      toast("Chave PIX salva");
    } catch (e){
      b.disabled = false; b.textContent = "Salvar";
      toast("Não deu para salvar: " + (e.message || e));
    }
  };

  setTimeout(() => $("#pxChave").focus(), 60);
}
